import DashboardNavItem from '@features/base/private/components/DashboardNavItem';
import ManageAccountNavItem from '@features/base/private/components/ManageAccountNavItem';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import HelpMenuNavItem from './components/HelpMenuNavItem';
import ReferenceMenuNavItem from './components/ReferenceMenuNavItem';
import { PermissionsEnum } from '@protos/user';
import { useUserContext } from '@shared/contexts/UserContextProvider';

const StyledPaper = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: '2%',
  left: 10,
  right: 10,
  backgroundColor: theme.palette.background.lighter,
  borderRadius: 15,
  zIndex: 1000,
  width: '80%',
  maxWidth: 400,
  margin: '0 auto',
  border: `1px solid ${theme.palette.divider}`,
}));

export default function MobileNavBar() {
  const user = useUserContext();
  const isPremiumUser = user && !user?.permissions?.includes(PermissionsEnum.FREEMIUM);
  return (
    <StyledPaper>
      <Stack direction="row" justifyContent="space-around" alignItems="center">
        <DashboardNavItem isPremiumUser={isPremiumUser ?? false} />
        {isPremiumUser && <ReferenceMenuNavItem />}
        <HelpMenuNavItem />
        <ManageAccountNavItem />
      </Stack>
    </StyledPaper>
  );
}
